import { render, staticRenderFns } from "./NewCampaign.vue?vue&type=template&id=724129a9&"
import script from "./NewCampaign.vue?vue&type=script&lang=js&"
export * from "./NewCampaign.vue?vue&type=script&lang=js&"
import style0 from "./NewCampaign.vue?vue&type=style&index=0&id=724129a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports